import React from 'react';
import {connect} from 'react-redux';
import SideMenu from '../Presentation/Navigation/SideMenu';
import Calendar from '../Presentation/Calendar';
import SidebarPage from '../Presentation/SidebarPage';
import ProfileMenu from '../Presentation/Navigation/ProfileMenu';
import Loader from '../Presentation/Loader';

class StatisticsPage extends React.Component {
    render() {
        const sidebar = <SideMenu items={this.props.sideMenu}><ProfileMenu /></SideMenu>;
        const {minutesMeditating, meditationDates, completedMeditationsCount, statsPending} = this.props;
        return <SidebarPage sidebar={sidebar} title="Статистики">
            <section className="meditation-calendar relative">
                <Loader show={statsPending} />
                <Calendar className={statsPending ? "loading" : null} highlights={meditationDates}/>
            </section>
            <section className="statistics relative">
                <Loader show={statsPending} />
                <div className={statsPending ? "loading" : null}>
                    <div className="statistics-item">
                        <div className="number-field">
                            <div className="number">{minutesMeditating}</div>
                            <p>минути</p>
                        </div>
                        <h4>Общо минути <br />медитация</h4>
                    </div>
                    <div className="statistics-item">
                        <div className="number-field">
                            <div className="number">{completedMeditationsCount}</div>
                            <p>сесии</p>
                        </div>
                        <h4>Завършени <br />сесии</h4>
                    </div>
                </div>
            </section>

        </SidebarPage>
    }
}

const mapStateToProps = (state) => {
    return {
        meditationDates: state.user.userStats.meditatedAt,
        minutesMeditating: state.user.userStats.minutesMeditating,
        completedMeditationsCount: state.user.userStats.completedMeditationsCount,
        statsPending: state.user.userStatsPending
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(StatisticsPage);



// WEBPACK FOOTER //
// ./src/components/Pages/Statistics.js